/* BRB Eyewear: privacy-friendly recent product history. Stored only in this browser. */
(() => {
  'use strict';
  const KEY = 'brb_viewed_frames_v1';
  const MAX = 24;

  function safeUrl(value) {
    try {
      const url = new URL(String(value || ''), location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) return '';
      const variant = url.searchParams.get('variant');
      return url.pathname + (variant && /^\d+$/.test(variant) ? '?variant=' + variant : '');
    } catch (_) { return ''; }
  }

  function safeImage(value) {
    try {
      const url = new URL(String(value || ''), location.origin);
      if (url.protocol !== 'https:' && url.origin !== location.origin) return '';
      if (url.origin !== location.origin && !/^(cdn\.shopify\.com|cdn\.shopifycdn\.net)$/.test(url.hostname)) return '';
      return url.href;
    } catch (_) { return ''; }
  }

  function read() {
    try {
      const found = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(found)) return [];
      return found.filter((item) =>
        item && typeof item.id === 'string' &&
        typeof item.title === 'string' && safeUrl(item.url)
      ).slice(0, MAX);
    } catch (_) { return []; }
  }

  function save(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX))); }
    catch (_) { /* Blocked storage: browsing remains functional without persistence. */ }
  }

  function recordProduct() {
    const marker = document.querySelector('[data-brb-viewed-product]');
    if (!marker) return;
    const productId = String(marker.dataset.productId || '');
    const url = safeUrl(location.pathname + location.search) || safeUrl(marker.dataset.productUrl);
    if (!productId || !url) return;
    const entry = {
      id: productId,
      title: String(marker.dataset.productTitle || 'Optical frame').slice(0, 180),
      url,
      image: safeImage(marker.dataset.productImage),
      viewedAt: Date.now()
    };
    const items = read().filter((item) => item.id !== productId);
    items.unshift(entry);
    save(items);
  }

  function make(tag, className, textValue) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (textValue !== undefined) node.textContent = textValue;
    return node;
  }

  function render() {
    const root = document.querySelector('[data-brb-history-page]');
    if (!root) return;
    const grid = root.querySelector('[data-brb-history-grid]');
    const empty = root.querySelector('[data-brb-history-empty]');
    const clear = root.querySelector('[data-brb-history-clear]');
    const count = root.querySelector('[data-brb-history-count]');
    const back = root.querySelector('[data-brb-history-back]');
    if (!grid || !empty || !clear || !count || !back) return;
    const items = read();
    grid.replaceChildren();
    count.textContent = (items.length === 1 ? root.dataset.brbI18nOne || '%COUNT% frame' : root.dataset.brbI18nMany || '%COUNT% frames').replace('%COUNT%', String(items.length));
    const none = items.length === 0;
    empty.hidden = !none;
    grid.hidden = none;
    clear.hidden = none;
    back.hidden = none;
    if (none) return;
    back.href = safeUrl(items[0].url) || root.querySelector('.brb-history-shop')?.getAttribute('href') || '/collections/all';
    items.forEach((item, index) => {
      const href = safeUrl(item.url);
      if (!href) return;
      const link = make('a', 'brb-history-card');
      link.href = href;
      const media = make('div', 'brb-history-image');
      const src = safeImage(item.image);
      if (src) {
        const img = document.createElement('img');
        img.src = src;
        img.alt = item.title;
        img.loading = 'lazy';
        img.decoding = 'async';
        media.appendChild(img);
      } else {
        media.appendChild(make('span', 'brb-history-no-image', 'BRB Eyewear'));
      }
      const text = make('div', 'brb-history-card-body');
      text.appendChild(make('span', 'brb-history-index', index === 0 ? root.dataset.brbI18nRecent || 'Most recently viewed' : root.dataset.brbI18nPrevious || 'Previously viewed'));
      text.appendChild(make('h2', 'brb-history-title', item.title));
      const action = make('span', 'brb-history-action', root.dataset.brbI18nView || 'View frame →');
      text.appendChild(action);
      link.append(media, text);
      grid.appendChild(link);
    });
  }

  function initialize() {
    recordProduct();
    render();
  }

  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.closest('variant-picker') && document.querySelector('[data-brb-viewed-product]')) {
      queueMicrotask(recordProduct);
    }
  });

  document.addEventListener('click', (event) => {
    const clearButton = event.target instanceof Element ? event.target.closest('[data-brb-history-clear]') : null;
    if (!clearButton) return;
    try { localStorage.removeItem(KEY); } catch (_) {}
    render();
  });

  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
